// filter-cards.js

// Handles click-based filtering for all card-filter elements
function bindFilterCardsToFacetForms() {
  document.querySelectorAll("[data-filter-param]").forEach((card) => {
    const paramName = card.dataset.filterParam;
    const value = card.dataset.filterValue;

    const desktopForm = document.querySelector("#FacetFiltersForm");
    const mobileForm = document.querySelector("#FacetFiltersFormMobile");

    card.addEventListener("click", (e) => {
      e.preventDefault();

      [desktopForm, mobileForm].forEach((form) => {
        if (!form) return;

        // Remove existing for param
        form
          .querySelectorAll(`[name="${paramName}"]`)
          .forEach((el) => el.remove());

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = paramName;
        input.value = value;
        form.appendChild(input);

        window.scrollTo({ top: 251, behavior: "smooth" });

        const event = new Event("input", { bubbles: true });
        Object.defineProperty(event, "target", {
          value: input,
          enumerable: true,
        });
        Object.defineProperty(event, "srcElement", {
          value: input,
          enumerable: true,
        });

        const wrapper = form.closest("facet-filters-form");
        if (wrapper && typeof wrapper.onSubmitHandler === "function") {
          try {
            wrapper.onSubmitHandler(event);
          } catch (err) {
            console.warn("FacetFiltersForm fallback triggered:", err);
            const params = new URLSearchParams(new FormData(form)).toString();
            if (typeof FacetFiltersForm !== "undefined") {
              FacetFiltersForm.renderPage(params);
            }
          }
        }
      });

      // Visual state
      document
        .querySelectorAll(`[data-filter-param="${paramName}"]`)
        .forEach((el) => el.classList.remove("card-filter--active"));
      card.classList.add("card-filter--active");
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindFilterCardsToFacetForms);
} else {
  bindFilterCardsToFacetForms();
}

document.addEventListener("facet:updated", () => {
  bindFilterCardsToFacetForms();
});
